<template>
  <div class="filter-container">
    <header>
      <h3>{{ title }}</h3>
      <span class="clear" @click="$emit('clear-filter-selections', title)"
        >clear</span
      >
      <!--  pass back which filter it is to clear -->
    </header>
    <div v-for="item of list" :key="item.label">
      <div class="filter-box">
        <ChildList
          :listItem="item"
          v-if="
            item.children &&
            item.children.length > 0 &&
            item.children[0].label !== ''
          "
        />
        <!-- && item.children[0].label !== ''" -->
        <div class="filter-row" v-else>
          <label>
            <input
              type="checkbox"
              value="filter-value"
              v-model="item.checked"
              @change="
                $emit(
                  'filter-update',
                  handleCheckboxInputChange($event),
                  item.label,
                  item.type,
                  'child'
                )
              "
            />
            <span v-if="item.label">{{ item.label }}</span>
            <!---->
            <span v-else>{{ item }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ChildList from "./ChildList.vue";
import type { FilterListItem } from "@/shared/ui/filter-container/filterListItem";

defineProps<{
  title: string;
  list: FilterListItem[];
}>();

function handleCheckboxInputChange(event: Event): boolean {
  return (event.target as HTMLInputElement).checked;
}
</script>

<style scoped lang="scss">
.filter-container {
  padding: 10px 20px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background: white;
  margin-bottom: 20px;
  > header {
    display: flex;
    align-items: center;
    .clear {
      margin-left: auto;
      color: #999;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
label {
  font-size: 13px;
  margin-bottom: 0;
  span {
    top: -2px;
    margin-left: 2px;
    position: relative;
  }
}
h3 {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
